import { Injectable } from '@angular/core'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { ModalPositionService } from '../../../services/modal-position.service'
import { CreateNewFilterGroupModalComponent } from './create-new-filter-group-modal.component'

export enum CreateNewFilterGroupModalAction {
  SAVE,
  SAVE_AND_APPLY,
}
export interface CreateNewFilterGroupModalResponse {
  name: string
  description: string
  action: CreateNewFilterGroupModalAction
}

@Injectable()
export class CreateNewFilterGroupModalService {
  constructor(
    private readonly modalService: NgbModal,
    private readonly modalPositionService: ModalPositionService,
  ) {}

  open(): Promise<CreateNewFilterGroupModalResponse> {
    const compKey = 'create-new-filter-group'
    const uniqueId = compKey + '-' + Date.now()
    const modalRef = this.modalService.open(
      CreateNewFilterGroupModalComponent,
      {
        size: 'md',
        keyboard: false,
        windowClass: uniqueId,
        beforeDismiss: () => {
          return this.modalPositionService.handleModalPositionSaveOnDismiss(
            uniqueId,
            compKey,
          )
        },
      },
    )
    this.modalPositionService.handleModalPositionSetup(uniqueId, compKey)
    return modalRef.result
  }
}
